export default {
    sidebarContainer: { 
        display: 'flex', 
        height: 'calc(100vh - 73px)', 
    },
    menuGroupContainer: { 
        display: 'flex', 
        flexDirection: "column", 
        flex: 1,
    },
    overflowShow: {
        overflowY: 'auto', 
        overflowX: 'hidden',
    },
    overflowHidden: {
        overflowY: 'hidden', 
        overflowX: 'hidden',
    }
}